<template>
    <div>
        <el-dialog
            title="企胜力服务协议和条款"
            :visible.sync="clause"
            width="580px"
            height="460px"
            :before-close="handleClose">
           <div v-html="detail" style="height:400px;overflow: auto;"></div>
        </el-dialog>
    </div>
</template>

<script>
import { gettext } from '@/api/api'
export default {
    name:'Clause',
    data(){
        return{
            detail:'dfdfdf'
        }
    },
    mounted(){ 
       this.getTextDetail()
    },
    methods:{
        handleClose() {
           this.$emit('hideClaMe')             
        },
        getTextDetail(){
            var that = this
            let data = {
               
            };
            gettext(data)
            .then(res => {      
                that.detail = res.body.result.text
                  
            })
            .catch(err => {});
        }
    },
    props:['clause']   
}
</script>

<style scoped>

 
</style>


// WEBPACK FOOTER //
// src/components/Clause.vue